import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Home/Homepage.css";
import "../Trading/CurrencyPairManagementPage.css";

const STATIC_PACKAGES = [
  { id: "sp1", coin: "ETH", packageName: "ETH Staking 30D", apy: 5, lockDays: 30, minAmount: 1, maxAmount: 100, status: "Active", totalStaked: "1250.5", users: 342, createdAt: "2025-01-15" },
  { id: "sp2", coin: "BTC", packageName: "BTC Staking 90D", apy: 4.5, lockDays: 90, minAmount: 0.01, maxAmount: 10, status: "Active", totalStaked: "45.2", users: 128, createdAt: "2025-01-20" },
  { id: "sp3", coin: "USDT", packageName: "USDT Flexible", apy: 3, lockDays: 0, minAmount: 100, maxAmount: 10000, status: "Active", totalStaked: "250000", users: 856, createdAt: "2025-02-01" },
  { id: "sp4", coin: "BNB", packageName: "BNB Lock 60D", apy: 6, lockDays: 60, minAmount: 10, maxAmount: 500, status: "Active", totalStaked: "3200", users: 201, createdAt: "2025-02-05" },
  { id: "sp5", coin: "SOL", packageName: "SOL Staking 30D", apy: 7, lockDays: 30, minAmount: 50, maxAmount: 5000, status: "Inactive", totalStaked: "8500", users: 95, createdAt: "2025-02-10" },
  { id: "sp6", coin: "XRP", packageName: "XRP 90D Lock", apy: 4, lockDays: 90, minAmount: 500, maxAmount: 50000, status: "Active", totalStaked: "125000", users: 67, createdAt: "2025-02-12" },
];

const StakingPackagesPage = () => {
  const [packages, setPackages] = useState(STATIC_PACKAGES);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [listModal, setListModal] = useState(null);

  const filtered = packages.filter(
    (p) =>
      (p.coin?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.packageName?.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (!statusFilter || p.status === statusFilter)
  );
  const totalRows = filtered.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const pageStart = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const pageEnd = Math.min(currentPage * rowsPerPage, totalRows);
  const paginated = filtered.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const handleToggleStatus = (pkgId) => {
    const pkg = packages.find((p) => p.id === pkgId);
    if (!pkg) return;
    const newStatus = pkg.status === "Active" ? "Inactive" : "Active";
    setPackages((prev) => prev.map((p) => (p.id === pkgId ? { ...p, status: newStatus } : p)));
    setListModal(null);
  };

  return (
    <main className="dashboard-main dashboard-subpage currency-pair-page">
      <section className="dashboard-hero currency-pair-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Staking</span>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Staking Packages</span>
          </p>
          <h1 className="dashboard-hero__title">Staking Packages</h1>
          <p className="dashboard-hero__subtitle">View and manage staking packages</p>
        </div>
        <div className="currency-pair-hero__actions">
          <Link to="/dashboard/staking/add-package" className="cp-btn cp-btn--primary cp-btn--add">
            <i className="fas fa-plus" /> Add Package
          </Link>
        </div>
        <div className="dashboard-hero__icon currency-pair-hero__icon">
          <i className="fas fa-coins" />
        </div>
      </section>

      <div className="dashboard-body currency-pair-body">
        <div className="currency-pair-card currency-pair-card--table-only">
          <div className="currency-pair-table-block">
            <div className="currency-pair-table-head">
              <div className="currency-pair-section-head">
                <i className="fas fa-list" />
                <h2>Packages ({packages.length})</h2>
              </div>
              <div className="cp-table-actions">
                <div className="cp-filter-wrap">
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="cp-filter-select"
                  >
                    <option value="">All status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="cp-search-wrap">
              <i className="fas fa-search" />
              <input
                type="text"
                placeholder="Search by coin or package name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="cp-search-input"
              />
            </div>
            <div className="cp-table-wrap">
              <table className="cp-table">
                <thead>
                  <tr>
                    <th>Package</th>
                    <th>Coin</th>
                    <th>APY</th>
                    <th>Lock (Days)</th>
                    <th>Min / Max</th>
                    <th>Total Staked</th>
                    <th>Users</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginated.map((row) => (
                    <tr key={row.id}>
                      <td><strong>{row.packageName}</strong></td>
                      <td>{row.coin}</td>
                      <td>{row.apy}%</td>
                      <td>{row.lockDays === 0 ? "Flexible" : row.lockDays}</td>
                      <td>{row.minAmount} / {row.maxAmount}</td>
                      <td>{row.totalStaked} {row.coin}</td>
                      <td>{row.users}</td>
                      <td>
                        <span className={`cp-badge cp-badge--${row.status === "Active" ? "global" : "local"}`}>
                          {row.status}
                        </span>
                      </td>
                      <td>
                        <div className="cp-action-btns">
                          <Link to={`/dashboard/staking/edit-package/${row.id}`} className="cp-action-btn cp-action-btn--list">
                            <i className="fas fa-edit" /> Edit
                          </Link>
                          <button
                            type="button"
                            className={`cp-action-btn ${row.status === "Active" ? "cp-action-btn--delist" : "cp-action-btn--list"}`}
                            onClick={() => setListModal(row.id)}
                            title={row.status === "Active" ? "Deactivate" : "Activate"}
                          >
                            <i className={`fas ${row.status === "Active" ? "fa-pause" : "fa-play"}`} />
                            {row.status === "Active" ? "Deactivate" : "Activate"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="cp-pagination">
              <div className="cp-pagination-rows">
                <span>Rows per page:</span>
                <select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <div className="cp-pagination-info">
                {pageStart}-{pageEnd} of {totalRows}
              </div>
              <div className="cp-pagination-nav">
                <button
                  type="button"
                  disabled={currentPage <= 1}
                  className="cp-pagination-btn"
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                >
                  <i className="fas fa-chevron-left" />
                </button>
                <button
                  type="button"
                  disabled={currentPage >= totalPages}
                  className="cp-pagination-btn"
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                >
                  <i className="fas fa-chevron-right" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {listModal && (() => {
        const pkg = packages.find((p) => p.id === listModal);
        if (!pkg) return null;
        const isActive = pkg.status === "Active";
        return (
          <div className="cp-modal-overlay" onClick={() => setListModal(null)}>
            <div className="cp-modal" onClick={(e) => e.stopPropagation()}>
              <h3>{isActive ? "Deactivate Package" : "Activate Package"}</h3>
              <p>
                {isActive
                  ? `Deactivate ${pkg.packageName}? Users won't be able to stake in this package.`
                  : `Activate ${pkg.packageName}? Users will be able to stake.`}
              </p>
              <div className="cp-modal-actions">
                <button type="button" className="cp-btn cp-btn--outline" onClick={() => setListModal(null)}>Cancel</button>
                <button type="button" className="cp-btn cp-btn--primary" onClick={() => handleToggleStatus(listModal)}>
                  <i className="fas fa-check" /> Confirm
                </button>
              </div>
            </div>
          </div>
        );
      })()}
    </main>
  );
};

export default StakingPackagesPage;
